/**
 * Frontend Idempotency Key Generator
 * Mirrors the backend implementation for consistency
 */

export const generateOrderIdempotencyKey = (userID, orderType, tableNo) => {
    // Use table number for dine-in, order type for others
    const identifier = tableNo || orderType || 'online';
    
    // Unix timestamp in seconds (1 second precision)
    const timestamp = Math.floor(Date.now() / 1000);
    
    const key = `ORDER-${userID}-${identifier}-${timestamp}`;
    
    console.log(`[IDEMPOTENCY-FRONTEND] Generated key: ${key}`);
    return key;
};

export const isValidIdempotencyKey = (key) => {
    if (!key || typeof key !== 'string') return false;
    const pattern = /^ORDER-\d+-[\w-]+-\d+$/;
    return pattern.test(key);
};
